export const ADD_LOCATION_CHANGE_SUCCESS_RESPONSE = 'CrewMemberLocationChangeSuccessResponse';

export const DEFAULT_VALUES = {
	cityId: '',
	from: '',
	fromTime: '',
	note: '',
};
